// Mock data for Anitix.cloud site
export const BRAND = {
  name: 'ANITIX.CLOUD',
  short: 'ANITIX',
  domain: 'anitix.cloud',
  email: 'pratik@anitix.cloud',
  parent: 'Anitix Private Limited'
};

export const NAV_LINKS = [
  { label: 'Staffing', href: '#staffing' },
  { label: 'Services', href: '#services' },
  { label: 'AI Governance', href: '#ai' },
  { label: 'Work', href: '#work' },
  { label: 'Studio', href: '#studio' },
  { label: 'Contact', href: '#contact' }
];

export const MARQUEE_ITEMS = [
  'Staffing',
  'Product Engineering',
  'Cloud',
  'AI & Data',
  'Design',
  'Managed Teams'
];

export const STATS = [
  { value: '500+', label: 'Engineers Placed' },
  { value: '48h', label: 'Avg. Match Time' },
  { value: '40+', label: 'Product Teams Built' },
  { value: '96%', label: 'Client Retention' }
];

export const STAFFING_STEPS = [
  {
    n: '01',
    title: 'Vetted Talent, On Demand',
    body: 'We maintain a bench of senior engineers, designers and product minds — pre-screened across systems design, delivery and culture. You get the right person, not just an available one.'
  },
  {
    n: '02',
    title: 'Matched In 48 Hours',
    body: 'Tell us the stack and the shape of the problem. We short-list battle-tested talent from our network within two working days — no lengthy sourcing cycles.'
  },
  {
    n: '03',
    title: 'Embedded, Not Outsourced',
    body: 'Our people plug directly into your rituals, tooling and codebase. They act as your team — accountable to your roadmap, invested in your outcomes.'
  },
  {
    n: '04',
    title: 'Scale Up. Scale Down.',
    body: 'Contract, contract-to-hire or full build-out. Flex capacity as the roadmap breathes, without the overhead of traditional hiring.'
  }
];

export const SERVICES = [
  { n: '01', title: 'Tech Staffing', body: 'Senior engineers & product talent embedded into your team, matched in days.', flagship: true, big: true },
  { n: '02', title: 'Product Engineering', body: 'End-to-end builds — from zero-to-one MVPs to scaled platform teams.' },
  { n: '03', title: 'Cloud & DevOps', body: 'Infrastructure, CI/CD and reliability engineering that ships.' },
  { n: '04', title: 'AI & Data', body: 'Applied ML, data pipelines and LLM features wired into real products.' },
  { n: '05', title: 'UX / UI Design', body: 'Interface craft and design systems that make software feel effortless.' },
  { n: '06', title: 'Managed Teams', body: 'Fully-run pods with a lead, cadence and delivery ownership.' }
];

export const AI_STEPS = [
  {
    n: '01',
    title: 'AI Readiness Audit',
    body: "We map every function — engineering, ops, support, sales — to find where AI creates real leverage, and where it doesn't. A clear, prioritised roadmap before a single dollar is spent."
  },
  {
    n: '02',
    title: 'Stable Implementation',
    body: 'Production-grade rollouts with guardrails, evals and human-in-the-loop checkpoints. AI that behaves predictably across the company — not brittle demos.'
  },
  {
    n: '03',
    title: 'Cost Optimisation',
    body: 'Right-sized models, smart routing, caching and prompt hygiene to cut token spend by up to 60% — without sacrificing quality or speed.'
  },
  {
    n: '04',
    title: 'Governance & Compliance',
    body: 'Usage policies, access controls, monitoring and audit trails so leadership stays in control of risk, data and spend as adoption scales.'
  }
];

export const WORK = [
  {
    tag: 'Health Tech',
    title: 'Vitalis Care Platform',
    body: 'A patient-first telehealth platform — bookings, records and remote monitoring — built by an embedded pod of six.',
    tags: ['React Native', 'HIPAA', 'FHIR', 'AWS'],
    image: 'https://images.pexels.com/photos/4108167/pexels-photo-4108167.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940'
  },
  {
    tag: 'Ecommerce',
    title: 'Kart Commerce Engine',
    body: 'A headless commerce experience handling six-figure daily GMV with sub-second storefronts.',
    tags: ['Next.js', 'Stripe', 'Headless', 'Edge'],
    image: 'https://images.unsplash.com/photo-1674027392887-751d6396b710?auto=format&fit=crop&w=940&q=80'
  },
  {
    tag: 'Travel',
    title: 'Wander Booking Suite',
    body: 'A dynamic travel booking engine with real-time inventory, fare rules and itinerary intelligence.',
    tags: ['Node', 'GraphQL', 'React', 'Maps'],
    image: 'https://images.pexels.com/photos/7412022/pexels-photo-7412022.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940'
  }
];

export const SERVICE_OPTIONS = [
  'Tech Staffing',
  'Product Engineering',
  'Cloud & DevOps',
  'AI & Data',
  'UX / UI Design',
  'Managed Teams'
];
